<template>
    <div>
        <headerNotice routerName="订单结算"></headerNotice>
        <!-- 头部操作栏 -->
        <div class="handleBar">
            <el-button type="primary" @click="addDialog">
                <i class="el-icon-plus"></i> 新增
            </el-button>
        </div>
        <!-- 单位列表 -->
        <div class="unitBox">
            <el-table class="tableBox" :data="items" style="width:100%" fit v-loading="loading">
                <el-table-column align="center" prop="name" label="批次名称"></el-table-column>
                 <!-- <el-table-column align="center" prop="startTime" label="结算状态"></el-table-column> -->
                  <el-table-column align="center" prop="startTime" label="开始时间"></el-table-column>
                <el-table-column align="center" prop="endTime" label="截至时间"></el-table-column>
                <el-table-column align="center" prop="count" label="总金额"></el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="small" type="warning" @click="editClick(scope.row)">明细</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync='currentPage'
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            ></el-pagination>
        </div>

        <!-- 新增框 -->
        <el-dialog title="新增品牌" :visible.sync="showDialog" width="30%">
            <el-form class="signUp_Form" label-width="125px">
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="批次名称" :rules="[{'required':true}]">
                            <el-input v-model="name" placeholder="批次名称" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                 <el-row>
                    <el-col :span="20">
                     <el-form-item label="订单日期" :rules="[{'required':true}]">
                              <el-date-picker
                        @change="durationChange"
                        style="width:240px;"
                        v-model="duration"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                        </el-form-item>      
                    </el-col>
                </el-row>
                 <el-row>
                    <el-col :span="20">
                        <el-form-item label="结算仓库" :rules="[{'required':true}]">
                            <el-select filterable  v-model="settlementHouseID" placeholder="请选择仓库">
                            <el-option label="全部" :value="0"></el-option>
                            <el-option
                                v-for="item in houseList"
                                :key="item.houseList"
                                :label="item.houseName"
                                :value="item.houseID"
                            ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                 <el-row>
                    <el-col :span="20">
                        <el-form-item label="批次名称" :rules="[{'required':true}]">
                            <el-input v-model="brandName" placeholder="批次名称" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="saveBox">
                    <el-button type="primary" class="saveUnitBtn" @click="saveUnit">保存</el-button>
                </div>
            </el-form>
        </el-dialog>
     
    </div>
</template>

<script>
import headerNotice from '../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            loading: true,
            totalCount: 0,//总数据条数
            currentPage: 1,
            name:"",
            settlementHouseID:0,
            maxResultCount: 10, //默认一页显示的个数,
            items: [],
             houseList: [],//所属仓库
            showDialog: false,//增加分类弹框
            brandName: '',
            startTime:"",
            endTime:"",
             duration: [],
            editDialog: false,//关闭分类弹框
            editForm: {

            },
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        let self = this;
        this.getDatas({
            MaxResultCount: this.maxResultCount,
        });
        this.getSelectData();

    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/SettlementService/GetSettlementBatch",
                params: params,
                success(res) {
                    
                    self.items = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
           editClick(row) {
            this.$router.push({
                'path': '/settlementorder',
                'query': {
                    'batchID': row.batchID
                }
            })
        },
           //获取下拉数据
	  getSelectData() {
		  let self = this;
		  $http.GET({
			  url: this.$store.state.apiUrl + "/api/services/app/SettlementService/GetSettlementBatch",
			  success(res) {
				  self.houseList = res;
			  },
			  fail(res) {
			  }
		  })
	  },
          // 根据时间
        durationChange(val) {
        if (!val) {
            val = [];
        }
        this.startTime = val[0];
        this.endTime = val[1];
         this.duration=val;
        },
        //添加商品单位
        addDialog() {
            this.showDialog = true;
        },
        //保存添加品牌
        saveUnit() {
            let self = this;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/SettlementService/Create",
                data: {
                    name: this.name,
                    startTime: this.startTime,
                    endTime: this.endTime,
                     launchHouseID:0,
                     settlementType:1,
                  settlementHouseID :0,
                    settlementHouseID: this.settlementHouseID,
                },
                success(res) {
                    self.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    self.getDatas();
                    self.currentPage = 1
                    self.showDialog = false;
                },
                fail(res) {

                }
            })
        },
      
      
        //删除单位
        deleteBtn(row) {
            let self = this;
            this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                $http.DELETE({
                    url: this.$store.state.apiUrl + "/api/services/app/IAdmintemBrand/DeleteBrand",
                    params: {
                        Id: row.brandID,
                    },
                    success(res) {
                        self.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        self.getDatas();
                        self.currentPage = 1
                    },
                    fail(res) {

                    }
                })
            }).catch(() => {

            });
        },
        //一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
            };
            this.getDatas(params);
        },
        //跳转到指定页
        handleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = {
                SkipCount: skipCount,
                MaxResultCount: this.maxResultCount,
            };
            this.getDatas(params);
        },
    }
}
</script>

<style lang='scss' scoped>
// 头部操作栏
.handleBar {
    margin: 0px 120px;
    margin-top: 20px;
    padding: 20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
// 单位列表
.unitBox {
    padding: 20px 130px;
    .tableBox {
        border: 1px solid #c5c5c5;
    }
    ul {
        li {
            height: 80px;
            border-bottom: 1px solid #c5c5c5;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-left: 20px;
            &:nth-last-child(1){
                border: none;
            }
        }
    }
}
.saveBox {
    width: 100%;
    display: flex;
    justify-content: center;
}
</style>